import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type { IGetPartnerSecurityDocumentUrlResponse } from "./getPartnerSecurityDocumentUrl.jsonschema";

export interface IGetPartnerSecurityDocumentUrlParams {
  partner_id: string;
  document_key: string;
}

export const getPartnerSecurityDocumentUrl = (axios: IAxiosInstance) => {
  return async (
    params: IGetPartnerSecurityDocumentUrlParams
  ): Promise<string> => {
    const { partner_id, document_key } = params;
    const response = await axios.noRetry.get<
      IApiResponse<IGetPartnerSecurityDocumentUrlResponse>
    >(`/api/partners/${partner_id}/security-documents/url`, {
      params: { document_key },
    });
    const resData = response.data;
    if (resData?.success && resData.data?.url) {
      return resData.data.url;
    }
    throw new Error("Something went wrong");
  };
};
